<div class="my-content" *ngIf="!migratedUsererror">
  <app-loader [isLoading]="isLoading"></app-loader>
  
  <div class="top">
    <div class="title">{{title}}</div>
    <div class="description">{{description}}</div>
  </div>

  <form class="form" (ngSubmit)="onSubmit()" [formGroup]="loginForm">
    <ng-container *ngIf="unExpectedError">
      <div class="error">
          <i class="material-icons">warning</i>
          <span [translate]="unExpectedError"></span>
      </div>
    </ng-container>
    <app-input  inputType="email" [parentFormGroup]="loginForm" [formControl]="userEmail" [placeholder]="'registration.email' | translate"
      inputId="signIn-input-email" [errorText]="'errors.invalid-email-format' | translate" [isRequired]="true"></app-input> 
    
    <fieldset formGroupName="password"  *ngIf="loginMode != LoginStates.EnterEmail">
      <app-input pattern="^.{6,}$" 
        [placeholder]="'registration.password' | translate"
        [inputType]="showPasswordText ? 'text': 'password'"
        [parentFormGroup]="passwordFormGroup" [formControl]="password"
        [class.has-errors]="this.loginMode === LoginStates.Login
        ? (this.passwordFormGroup.invalid && (this.password.dirty || this.password.touched))
        : this.passwordFormGroup.invalid && (this.confirmPassword.dirty || this.confirmPassword.touched)"
        inputId="signIn-input-password" [isRequired]="true">
        <span [class.hidden]="!password.value" class="show-hide form-control-feedback-text" (click)="showPasswordText = !showPasswordText"
          [translate]="showPasswordText ? 'form.hide' : 'form.show'">
        </span>
      </app-input>
    </fieldset>

    <ng-container *ngIf="loginMode === LoginStates.EnterEmail">
      <button type="submit" id="signIn-button-login" class="btn-redesign btn-redesign--primary continue" [disabled]="!userEmail.valid" translate="registration.continue"
      ></button>
    </ng-container>

    <ng-container *ngIf="loginMode === LoginStates.Login">
      <ng-container *ngIf="invalidCredError">
        <div class="error">
            <span [translate]="invalidCredError"></span>
        </div>
      </ng-container>
      <div class="remember-me-and-forgot-pass">
        <app-checkbox inputId="signIn-checkbox-rememberMe" [inverted]="true" [text]="'registration.remember-me' | translate" class="fixed-height" [formControl]="loginForm.get('rememberMe')" [parentFormGroup]="loginForm"></app-checkbox>
        <a id="signIn-link-forgot-password" translate="registration.forgot-password" (click)="showForgotPassword.emit({show: true, email: email})"></a>
      </div>
      <app-recaptcha [onSubmit]="getOnSubmit()" (recaptchaIdCreated)="recaptchaId=$event"></app-recaptcha>
      <button type="submit" id="signIn-button-login" class="btn-redesign btn-redesign--primary continue" [disabled]="!userEmail.valid || !password.valid" translate="registration.continue"
        angulartics2On="click" [angularticsProperties]="'_log_into_account' | listingTypeAnalyticsTag | async"
      ></button>
      <div class="go-back">
        <a (click)="setLoginMode(LoginStates.EnterEmail)" translate="registration.go-back"></a>
      </div>
    </ng-container>

    <ng-container *ngIf="loginMode === LoginStates.SignUp">
      <fieldset formGroupName="password" class="confirm-password">
        <app-input pattern="^.{6,}$"
        [placeholder]="'registration.confirm-password' | translate"
        [inputType]="showConfirmPasswordText ? 'text': 'password'"
        [parentFormGroup]="passwordFormGroup" [formControl]="confirmPassword"
        [class.has-errors]="this.passwordFormGroup.invalid && (this.confirmPassword.dirty || this.confirmPassword.touched)"
        inputId="input-account-confirm-password" [isRequired]="true">
          <span [class.hidden]="!confirmPassword.value" class="show-hide form-control-feedback-text" (click)="showConfirmPasswordText = !showConfirmPasswordText"
            [translate]="showConfirmPasswordText ? 'form.hide' : 'form.show'">
          </span>
          <p class="error-clue" *ngIf="this.passwordFormGroup.invalid && (this.confirmPassword.dirty || this.confirmPassword.touched)">Passwords don't match</p>
        </app-input>
      </fieldset>
      <app-recaptcha [onSubmit]="getOnSubmit()" (recaptchaIdCreated)="recaptchaId=$event"></app-recaptcha>
      <button type="button" class="btn-redesign btn-redesign--primary continue" [disabled]="!loginForm.valid" translate="registration.continue" (click)="sendGrecaptcha()"
        angulartics2On="click" [angularticsProperties]="'_register_for_account' | listingTypeAnalyticsTag | async"
      ></button>
      <div class="go-back">
        <a (click)="setLoginMode(LoginStates.EnterEmail)" translate="registration.go-back"></a>
      </div>
    </ng-container>
  </form>
  <div *ngIf="loginMode === LoginStates.EnterEmail" class="social-login">
    <div class="connect-with" translate="registration.connect-with"></div>
    <div class="icons is-flex">
      <div class="is-flex centered">
        <app-social provider="facebook"></app-social>
      </div>
      <div class="is-flex centered">
        <app-social provider="google"></app-social>
      </div>
    </div>
  </div>

  <div class="form-group terms">
    <span translate="registration.agree-to-continue"></span>&nbsp;
    <a target="_blank" rel="noopener" href="/editorial/copyright-terms-of-use/" translate="registration.terms-of-service"></a>&nbsp;
    <a target="_blank" rel="noopener" href="/editorial/privacy-policy/" translate="registration.privacy-policy"></a>
  </div>
</div>

<ng-container *ngIf="migratedUsererror">
  <div class="my-content migrated-user">
    <div translate="registration.migrated-user-title"></div>
    <div translate="registration.migrated-user-description"></div>
    <div class="go-back">
      <a (click)="setLoginMode(LoginStates.EnterEmail)" translate="registration.go-back"></a>
    </div>
  </div>
</ng-container>